import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';
import CardContext from './CardContext';
const SKELETON_HEIGHT_VALUE = 100;
const CardSection = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    children,
    title,
    actions,
    muted,
    skeletonHeight,
    skeletonWidth
  } = _ref;
  const {
    isLoading
  } = useContext(CardContext);
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('pgn__card-section', className, {
        'is-muted': muted
      })
    }, /*#__PURE__*/React.createElement(Skeleton, {
      containerClassName: "pgn__card-section-loader",
      height: skeletonHeight,
      width: skeletonWidth
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('pgn__card-section', className, {
      'is-muted': muted
    }),
    ref: ref
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "pgn__card-section-title"
  }, title), children, actions && /*#__PURE__*/React.createElement("div", {
    className: "pgn__card-section-actions"
  }, actions));
});
CardSection.propTypes = {
  /** Specifies class name to append to the base element. */
  className: PropTypes.string,
  /** Specifies contents of the component. */
  children: PropTypes.node,
  /** Specifies title of the `Section`. */
  title: PropTypes.node,
  /** Specifies node to render on the bottom right of the `Section` (i.e. `ActionRow`). */
  actions: PropTypes.node,
  /** Specifies whether to display `Section` with muted styling. */
  muted: PropTypes.bool,
  /** Specifies height of skeleton in loading state. */
  skeletonHeight: PropTypes.number,
  /** Specifies width of skeleton in loading state. */
  skeletonWidth: PropTypes.number
};
CardSection.defaultProps = {
  children: null,
  className: undefined,
  title: undefined,
  actions: undefined,
  muted: false,
  skeletonHeight: SKELETON_HEIGHT_VALUE,
  skeletonWidth: undefined
};
export default CardSection;
//# sourceMappingURL=CardSection.js.map